// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Wa7a","image":"Header_image__1LTDl","name":"Header_name__20ZIr","info":"Header_info__3EX-W","infoRow":"Header_infoRow__26yr4"};